import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import amplifyconfig from './aws-config';
import TrazerContainer from './containers/TrazerContainer';
import HashResult from './components/Trazer/HashResult';
import MainContainer from './containers/MainContainer';
import CertificateGenerator from './components/CertificateGenerator';
import Amplify from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';
import { withTranslation } from 'react-i18next';
Amplify.configure(amplifyconfig);

// Apply plugin with configuration
Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: amplifyconfig.aws_pubsub_region,
  aws_pubsub_endpoint: amplifyconfig.aws_pubsub_endpoint
}));

function App () {
  return (
    <Router>
      <Switch>
        <Route exact path='/search' component={TrazerContainer} />
        <Route
          exact
          path='/certificate/:chaincode/:key'
          component={CertificateGenerator}
        />
        <Route path='/search/:type/:key' component={HashResult} />
        <Route from='/' component={MainContainer} />
      </Switch>
    </Router>
  );
}

export default withTranslation()(App);
